

// Ay sayını hesabla
const getMonthsSince = (date) => {
    const now = new Date();
    const created = new Date(date);
    return (now.getFullYear() - created.getFullYear()) * 12 + 
           (now.getMonth() - created.getMonth());
};

// ========================================
// 🏆 BÜTÜN ROZETLƏR
// ========================================

export const BADGES = {
    // ========================================
    // SATIŞ ROZETLƏRI
    // ========================================
    sales_rookie: {
        id: 'sales_rookie',
        name: 'Yeni Satıcı',
        emoji: '🌱',
        icon: '/images/badges/sales_rookie.png', // ✅ Şəkil yolu
        color: '#10b981',
        requirement: 'İlk satış',
        condition: (seller) => seller.stats?.totalSales >= 1,
        order: 1,
        category: 'sales',
        adminOnly: false
    },
    sales_bronze: {
        id: 'sales_bronze',
        name: 'Bronz Satıcı',
        emoji: '🥉',
        icon: '/images/badges/sales_bronze.png',
        color: '#cd7f32',
        requirement: '10 satış',
        condition: (seller) => seller.stats?.totalSales >= 10,
        order: 2,
        category: 'sales',
        adminOnly: false
    },
    sales_silver: {
        id: 'sales_silver',
        name: 'Gümüş Satıcı',
        emoji: '🥈',
        icon: '/images/badges/sales_silver.png',
        color: '#c0c0c0',
        requirement: '50 satış',
        condition: (seller) => seller.stats?.totalSales >= 50,
        order: 3,
        category: 'sales',
        adminOnly: false
    },
    sales_gold: {
        id: 'sales_gold',
        name: 'Qızıl Satıcı',
        emoji: '🥇',
        icon: '/images/badges/sales_gold.png',
        color: '#ffd700',
        requirement: '100 satış',
        condition: (seller) => seller.stats?.totalSales >= 100,
        order: 4,
        category: 'sales',
        adminOnly: false
    },
    sales_platinum: {
        id: 'sales_platinum',
        name: 'Platin Satıcı',
        emoji: '💎',
        icon: '/images/badges/sales_platinum.png',
        color: '#e5e4e2',
        requirement: '500 satış',
        condition: (seller) => seller.stats?.totalSales >= 500,
        order: 5,
        category: 'sales',
        adminOnly: false
    },
    sales_legend: {
        id: 'sales_legend',
        name: 'Əfsanə Satıcı',
        emoji: '👑',
        icon: '/images/badges/sales_legend.png',
        color: '#9333ea',
        requirement: '1000 satış',
        condition: (seller) => seller.stats?.totalSales >= 1000,
        order: 6,
        category: 'sales',
        adminOnly: false
    },
    
    // ========================================
    // REYTİNQ ROZETLƏRI
    // ========================================
    rating_excellent: {
        id: 'rating_excellent',
        name: 'Əla Xidmət',
        emoji: '⭐',
        icon: '/images/badges/rating_excellent.png',
        color: '#eab308',
        requirement: '4.5+ reytinq (10+ rəy)',
        condition: (seller) => seller.stats?.rating >= 4.5 && seller.stats?.totalReviews >= 10,
        order: 7,
        category: 'rating',
        adminOnly: false
    },
    rating_perfect: {
        id: 'rating_perfect',
        name: 'Mükəmməl',
        emoji: '🌟',
        icon: '/images/badges/rating_perfect.png',
        color: '#f59e0b',
        requirement: '5.0 reytinq (20+ rəy)',
        condition: (seller) => seller.stats?.rating === 5.0 && seller.stats?.totalReviews >= 20,
        order: 8,
        category: 'rating',
        adminOnly: false
    },
    
    // ========================================
    // MÜDDƏT ROZETLƏRI
    // ========================================
    member_1month: {
        id: 'member_1month',
        name: '1 Aylıq Üzv',
        emoji: '📅',
        icon: '/images/badges/member_1month.png',
        color: '#3b82f6',
        requirement: '1 ay üzvlük',
        condition: (seller) => {
            const months = getMonthsSince(seller.createdAt);
            return months >= 1;
        },
        order: 9,
        category: 'member',
        adminOnly: false
    },
    member_6months: {
        id: 'member_6months',
        name: '6 Aylıq Üzv',
        emoji: '📆',
        icon: '/images/badges/member_6months.png',
        color: '#8b5cf6',
        requirement: '6 ay üzvlük',
        condition: (seller) => {
            const months = getMonthsSince(seller.createdAt);
            return months >= 6;
        },
        order: 10,
        category: 'member',
        adminOnly: false
    },
    member_1year: {
        id: 'member_1year',
        name: '1 İllik Üzv',
        emoji: '🎂',
        icon: '/images/badges/member_1year.png',
        color: '#ec4899',
        requirement: '1 il üzvlük',
        condition: (seller) => {
            const months = getMonthsSince(seller.createdAt);
            return months >= 12;
        },
        order: 11,
        category: 'member',
        adminOnly: false
    },
    
    // ========================================
    // XÜSUSI ROZETLƏR (Admin verir)
    // ========================================
    verified_seller: {
        id: 'verified_seller',
        name: 'Təsdiqlənmiş Satıcı',
        emoji: '✅',
        icon: '/images/badges/verified_seller.png',
        color: '#10b981',
        requirement: 'Admin tərəfindən təsdiqlənib',
        adminOnly: true,
        order: 12,
        category: 'special'
    },
    top_seller_month: {
        id: 'top_seller_month',
        name: 'Ayın Ən Yaxşısı',
        emoji: '🏆',
        icon: '/images/badges/top_seller_month.png',
        color: '#f59e0b',
        requirement: 'Ayın ən yaxşı satıcısı',
        adminOnly: true,
        order: 13,
        category: 'special'
    },
    fast_shipping: {
        id: 'fast_shipping',
        name: 'Sürətli Çatdırılma',
        emoji: '⚡',
        icon: '/images/badges/fast_shipping.png',
        color: '#eab308',
        requirement: 'Sürətli çatdırılma rekordu',
        adminOnly: true,
        order: 14,
        category: 'special'
    },
    quality_products: {
        id: 'quality_products',
        name: 'Keyfiyyətli Məhsullar',
        emoji: '💯',
        icon: '/images/badges/quality_products.png',
        color: '#8b5cf6',
        requirement: 'Keyfiyyət standartı',
        adminOnly: true,
        order: 15,
        category: 'special'
    },
    vip_seller: {
        id: 'vip_seller',
        name: 'VIP Satıcı',
        emoji: '👑',
        icon: '/images/badges/vip_seller.png',
        color: '#dc2626',
        requirement: 'Premium üzvlük',
        adminOnly: true,
        order: 16,
        category: 'special'
    }
};

// ========================================
// 🔧 HELPER FUNCTIONS
// ========================================

// Seller-in qazandığı rozetləri yoxla
export const checkSellerBadges = (sellerRaw) => {
    if (!sellerRaw) return [];

    // ✅ Normalizasiya — bəzi səhifələrdə (məs. məhsul detalı sellerInfo) statlar
    // düz (top-level) gəlir; badge şərtləri seller.stats?.* oxuyur. Hər ikisini dəstəklə.
    const seller = {
        ...sellerRaw,
        stats: sellerRaw.stats || {
            totalSales:   sellerRaw.totalSales   || 0,
            rating:       sellerRaw.rating        || 0,
            totalReviews: sellerRaw.totalReviews  || 0,
        },
    };

    const earnedBadges = [];
    
    Object.values(BADGES).forEach(badge => {
        // Admin rozetlərini yoxla
        if (badge.adminOnly) {
            if (seller.badges && seller.badges.some(b => b.badgeId === badge.id)) {
                earnedBadges.push(badge);
            }
            return;
        }
        
        // Avtomatik rozetləri yoxla
        if (badge.condition && badge.condition(seller)) {
            earnedBadges.push(badge);
        }
    });
    
    return earnedBadges.sort((a, b) => a.order - b.order);
};

// Badge-i ID-yə görə tap
export const getBadgeById = (badgeId) => {
    return BADGES[badgeId] || null;
};

// Kateqoriyaya görə rozetlər
export const getBadgesByCategory = (category) => {
    return Object.values(BADGES).filter(badge => badge.category === category);
};

// Bütün avtomatik rozetlər
export const getAutomaticBadges = () => {
    return Object.values(BADGES).filter(badge => !badge.adminOnly);
};

// Bütün admin rozetləri
export const getAdminBadges = () => {
    return Object.values(BADGES).filter(badge => badge.adminOnly);
};

// Seller-in növbəti rozeti
export const getNextBadge = (seller) => {
    const earnedBadges = checkSellerBadges(seller);
    const earnedIds = earnedBadges.map(b => b.id);
    
    // Növbəti avtomatik rozeti tap
    const automaticBadges = getAutomaticBadges();
    
    for (let badge of automaticBadges) {
        if (!earnedIds.includes(badge.id)) {
            return badge;
        }
    }
    
    return null;
};

export default BADGES;